import * as React from 'react';
import classnames from 'classnames';
import sanitizeHtml from 'sanitize-html';
import kebabCase from 'lodash/kebabCase';
import snakeCase from 'lodash/snakeCase';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';

import './freemium-popover.scss';

applyTranslations(require('./freemium-popover.i18n.json'));

type Props = {
  name: 'campaign' | 'collection' | 'insights' | 'discoveryContent',
  items: Array<string>,
  imageWidth: {
    [x: string]: number
  },
  contentClassname?: string,
  triggerComponent?: React.ReactNode
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong', 'br']
};

const FreemiumPopover = ({
  contentClassname,
  name,
  imageWidth,
  items,
  triggerComponent
}: Props) => {
  const contentClassnames = classnames({
    'freemium-popover__items': true,
    [`${String(contentClassname)}`]: Boolean(contentClassname)
  });

  const updatedName = snakeCase(name);

  return (
    <Popover
      classNamePopover="freemium-popover"
      classNameWrapper="freemium-popover__wrapper"
      triggerComponent={triggerComponent}
    >
      <div
        className="freemium-popover__title"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(__t(`freemium_popover.${updatedName}.title`), SANITIZE_HTML_CONFIG) }}
      />
      <div className={contentClassnames}>
        {
          items.map(item => (
            <React.Fragment
              key={item}
            >
              <div
                className="freemium-popover__item-title"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(__t(`freemium_popover.${updatedName}.items.${item}`), SANITIZE_HTML_CONFIG) }}
              />
              <img
                src={`/static/images/freemium-${kebabCase(updatedName)}-popup-${item}.png`}
                alt={__t(`freemium_popover.${updatedName}.items.${item}`)}
                className="freemium-popover__item-image"
                style={{ width: imageWidth[item] }}
              />
            </React.Fragment>
          ))
        }
      </div>
      <div className="freemium-popover__footer">
        <ActionButton
          color="primary"
          className="freemium-popover__button"
          customSize={{ width: 274 }}
          link={__t('freemium_popover.email')}
        >
          {__t('freemium_popover.button')}
        </ActionButton>
      </div>
    </Popover>
  );
};

export default FreemiumPopover;
